module.exports = __webpack_public_path__ + "img/责任大成立德树人(1).2b6938e5.gif";